<template>
  <div class="bigbox scroll">
    <p class="title">
      信息监测
    </p>
    <component :jumpData="jumpData" :is="name"></component>
  </div>
</template>

<script>
import territory from "../../views/infoMonitor/Territory";
import abroad from "../../views/infoMonitor/abroad";
import Follow from "../../views/infoMonitor/Follow";

export default {
  data() {
    return {
      tag: [],
      names: sessionStorage.getItem("names")
        ? sessionStorage.getItem("names")
        : "",
      num: "",
      //   今日已新增
      limit: "",
      //   机构可新增条数
      jc: "",
      name:  "territory",
      dataList: [],
      jumpData: {}
    };
  },
  components: {
    territory,
    abroad,
    Follow
  },
  watch: {
  },
  created() {
    
  },
  mounted() {
  },
  methods: {

  }
};
</script>
<style lang="scss" scoped>
.bigbox {
  padding: 24px;
  height: 100%;
  .title {
    font-size: 26px;
    font-weight: bold;
    color: #1a1a1a;
    margin-bottom: 24px;

    .title-test {
      font-size: 14px;
      color: #666;
      margin-left: 16px;
    }
  }

  .top {
    width: 100%;
    height: 54px;
    background: #ffffff;
    border-radius: 4px;
    margin: 24px 0;
    display: flex;
    padding-left: 48px;
    font-size: 16px;
    font-weight: bold;
    color: #333333;
    position: relative;
    z-index: 20;
    .Selectli {
      line-height: 54px;
      margin-right: 80px;
      color: #2e59ec;
      border-bottom: 2px solid #2e59ec;
      cursor: pointer;
    }

    .NoSelect {
      line-height: 54px;
      margin-right: 80px;
      cursor: pointer;
    }
  }
}
</style>
